/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAudienceFromJSON, ApiAudienceToJSON, } from './ApiAudience';
import { ApiCampaignLeadFromJSON, ApiCampaignLeadToJSON, } from './ApiCampaignLead';
import { ApiCampaignSplitUrlFromJSON, ApiCampaignSplitUrlToJSON, } from './ApiCampaignSplitUrl';
import { ApiCampaignStatusFromJSON, ApiCampaignStatusToJSON, } from './ApiCampaignStatus';
import { ApiCampaignTypeFromJSON, ApiCampaignTypeToJSON, } from './ApiCampaignType';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiExternalDomainFromJSON, ApiExternalDomainToJSON, } from './ApiExternalDomain';
import { ApiLandingPathFromJSON, ApiLandingPathToJSON, } from './ApiLandingPath';
import { ApiPersonalisationFromJSON, ApiPersonalisationToJSON, } from './ApiPersonalisation';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiCampaignFromJSON(json) {
    return ApiCampaignFromJSONTyped(json, false);
}
export function ApiCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audiences': !exists(json, 'audiences') ? undefined : (json['audiences'].map(ApiAudienceFromJSON)),
        'classificationItems': !exists(json, 'classificationItems') ? undefined : (json['classificationItems'].map(ApiClassificationItemFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'fallbackUrl': !exists(json, 'fallbackUrl') ? undefined : json['fallbackUrl'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'landingDomain': !exists(json, 'landingDomain') ? undefined : ApiExternalDomainFromJSON(json['landingDomain']),
        'landingDomainId': !exists(json, 'landingDomainId') ? undefined : json['landingDomainId'],
        'landingPath': !exists(json, 'landingPath') ? undefined : ApiLandingPathFromJSON(json['landingPath']),
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiUserFromJSON(json['lastUser']),
        'lastUserId': !exists(json, 'lastUserId') ? undefined : json['lastUserId'],
        'leadCount': !exists(json, 'leadCount') ? undefined : json['leadCount'],
        'leads': !exists(json, 'leads') ? undefined : (json['leads'].map(ApiCampaignLeadFromJSON)),
        'maxNumberOfLeads': !exists(json, 'maxNumberOfLeads') ? undefined : json['maxNumberOfLeads'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noCache': !exists(json, 'noCache') ? undefined : json['noCache'],
        'owner': !exists(json, 'owner') ? undefined : ApiUserFromJSON(json['owner']),
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'pending': !exists(json, 'pending') ? undefined : (new Date(json['pending'])),
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiPersonalisationFromJSON)),
        'probability': !exists(json, 'probability') ? undefined : json['probability'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'status': !exists(json, 'status') ? undefined : ApiCampaignStatusFromJSON(json['status']),
        'type': !exists(json, 'type') ? undefined : ApiCampaignTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'urls': !exists(json, 'urls') ? undefined : (json['urls'].map(ApiCampaignSplitUrlFromJSON)),
    };
}
export function ApiCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audiences': value.audiences === undefined ? undefined : (value.audiences.map(ApiAudienceToJSON)),
        'classificationItems': value.classificationItems === undefined ? undefined : (value.classificationItems.map(ApiClassificationItemToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'description': value.description,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'fallbackUrl': value.fallbackUrl,
        'id': value.id,
        'landingDomain': ApiExternalDomainToJSON(value.landingDomain),
        'landingDomainId': value.landingDomainId,
        'landingPath': ApiLandingPathToJSON(value.landingPath),
        'lastUser': ApiUserToJSON(value.lastUser),
        'lastUserId': value.lastUserId,
        'leadCount': value.leadCount,
        'leads': value.leads === undefined ? undefined : (value.leads.map(ApiCampaignLeadToJSON)),
        'maxNumberOfLeads': value.maxNumberOfLeads,
        'name': value.name,
        'noCache': value.noCache,
        'owner': ApiUserToJSON(value.owner),
        'ownerId': value.ownerId,
        'pending': value.pending === undefined ? undefined : (value.pending.toISOString()),
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiPersonalisationToJSON)),
        'probability': value.probability,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'status': ApiCampaignStatusToJSON(value.status),
        'type': ApiCampaignTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'urls': value.urls === undefined ? undefined : (value.urls.map(ApiCampaignSplitUrlToJSON)),
    };
}
